<template>
  <div id="app">
    <el-header>
			<v-header></v-header>
		</el-header>
    <router-view></router-view>
    <el-footer>
			<v-footer></v-footer>
		</el-footer>
  </div>
</template>

<script>
  import VHeader from "./components/header";
	import VFooter from "./components/footer";
  export default {
    name: 'App',
    components: {
      VHeader,VFooter
    }
  }
</script>

<style>
  body {
    margin: 0px;
    padding: 0px;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
  }
  #app {
    width: 100%;
    height: 100%;
    font-family: Avenir, Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    position: relative;
  }
  .el-header {
    width: 100%;
    height: 100px!important;
    background-color: #8e0001;
    position: fixed;
    top: 0;
    left: 0;
    padding: 0;
  }
  .el-footer {
    width: 100%;
    height: 80px!important;
    background-color: #8e0001;
    position: fixed;
    bottom: 0;
    left: 0;
    padding: 0;
  }
</style>
